import React, { useEffect } from 'react'
import indiaContact from '../../Image/Service/India-Contact.svg'
import phoneContact from '../../Image/Service/Phone-Contact.svg'
import canadaContact from '../../Image/Service/Canada-Contact.svg'
import mailContact from '../../Image/Service/Mail-Contact.svg'
import facebookContact from '../../Image/Service/Facebook-Contact.svg'
import instagramContact from '../../Image/Service/Instagram-Contact.svg'
import googleContact from '../../Image/Service/Google-Contact.svg'
import linkdinContact from '../../Image/Service/Linkdin-Contact.svg'
import youtubeContact from '../../Image/Service/Youtube-Contact.svg'
import { useFormik } from 'formik'
import * as Yup from 'yup';
import Swal from 'sweetalert2'
const ContactUs = () => {

  const contactVal = {
    name: "",
    email: "",
    phoneNo: "",
    subject: "",
    message: "",
    check: false
  }

  const contactValidation = Yup.object({
    name: Yup.string()
      .min(2, "Name must be at least 2 characters")
      .required("Name is required"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    phoneNo: Yup.string()
      .matches(/^\+?\d{10,15}$/, "Phone number must be valid with optional '+' and 10-15 digits")
      .required("Phone number is required"),
    subject: Yup.string()
      .required("Subject is required"),
    message: Yup.string()
      .required("Message is required"),
    check: Yup.boolean()
      .oneOf([true], "You must confirm you're not a robot")
  });

  const contactFormik = useFormik({
    initialValues: contactVal,
    validationSchema: contactValidation,
    onSubmit: async (values, { resetForm }) => {
      console.log(values);
      try {
        await fetch(
          "https://v1.nocodeapi.com/rinkuridota/google_sheets/bdmZdVGxPTkqHZud?tabId=Sheet1",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify([
              [values?.name, values?.email, values?.subject, values?.message, values?.phoneNo, new Date().toLocaleString()]
            ])
          }
        ).then((res) => {
          if (res.status === 200) {
            resetForm();
            Swal.fire({
              position: "top-end",
              toast: true,
              icon: "success",
              title: "Thank You For Contact Us",
              showConfirmButton: false,
              timer: 4000,
              showCloseButton: true,
              background: "black",
              color: "white",
              iconColor: "green"
            });
          }
        });
        // await emailjs
        // .send("service_ejkv38f", "template_963h23a", {
        //   name: values.name,
        //   email: values.email,
        //   subject: values.subject,
        //   message: values.message,
        //   phoneNo: values.phoneNo
        // } , {
        //   publicKey: "KXP9_pJo_Zr8bRw96"
        // })
        // .then(
        //   () => {
        //     console.log("SUCCESS!");
        //   },
        //   (error) => {
        //     console.log("FAILED...", error.text);
        //   }
        // );
      } catch (error) {
        console.error(error);
        // Display error message
      }
    }
  })

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);




  return (
    <>
      <div className='container py-12'>
        <div className=" bg-white mx-auto text-gray-800 shadow-purple-md md:rounded-xl ">
          <div className="flex flex-col md:flex-row gap-8 items-stretch">
            <div className="w-full md:w-1/2 lg:p-10 p-4 flex flex-col">
              <div>
                <h2 className="text-xl md:text-2xl font-bold text-purple-700 mb-2">Let’s get in touch</h2>
                <p className="mb-6 text-sm md:text-base">Ready to start a project?</p>
              </div>
              <div className="mb-6">
                <div className="flex items-center gap-2 mb-3">
                  <img src={indiaContact} alt="" className="w-7 h-7" />
                  <h3 className="text-lg font-semibold">India</h3>
                </div>
                <div className="flex items-center gap-2 text-md mb-3">
                  <a href="tel:+91 93288 81036" className='cursor-pointer'><img src={phoneContact} alt="" className="w-7 h-7" /></a>
                  <a href="tel:+91 93288 81036" className='cursor-pointer'><span>+91 93288 81036</span></a>
                </div>
                <p className="text-md leading-relaxed">102–103 Silver Point, Jivanjyot Circle, Nr Yogi chowk Road Surat -395010 (Head Office)</p>
                <p className="text-md leading-relaxed mt-1">402–405 Astha Shoppers NearBy BhagvanMahavir Collage, Vesu, Surat -395007 (Branch)</p>
              </div>
              <div className="mb-6">
                <div className="flex items-center gap-2 mb-3">
                  <img src={canadaContact} alt="" className="w-7 h-7" />
                  <h3 className="text-lg font-semibold">Canada</h3>
                </div>
                <div className="flex items-center gap-2 text-md mb-3">
                  <a href="tel:+15198817124" className='cursor-pointer'><img src={phoneContact} alt="" className="w-7 h-7" /></a>
                  <a href="tel:+15198817124" className='cursor-pointer'><span>+1 5198817124</span></a>
                </div>
                <p className="text-md leading-relaxed">855 King Street East, Unit 210 Cambridge, ON, Canada (Branch)</p>
              </div>
              <div className="flex items-center gap-2 text-md mb-6">
                <a href="mailto:Info@kalathiyainfotech.com" className='cursor-pointer'><img src={mailContact} alt="" className="w-7 h-7" /></a>
                <a href="mailto:Info@kalathiyainfotech.com" className='cursor-pointer'><span>Info@kalathiyainfotech.com</span></a>
              </div>
              <div className="flex flex-wrap gap-4  text-purple-600 text-xl mt-auto">
                <a href="https://www.facebook.com/kalathiyainfotech"><img src={facebookContact} alt="Facebook" className="w-8 h-8" /></a>
                <a href="https://www.instagram.com/kalathiya_infotech/"><img src={instagramContact} alt="Instagram" className="w-8 h-8" /></a>
                <a href="https://www.google.com/search?q=kalathiya+infotech&rlz=1C1GCEA_enIN1018IN1018&oq=Kalathiya+&aqs=chrome.0.69i59l2j69i57j69i59j69i60l4.17467j0j7&sourceid=chrome&ie=UTF-8"><img src={googleContact} alt="Google" className="w-8 h-8" /></a>
                <a href="https://www.linkedin.com/company/kalathiyainfotech/"><img src={linkdinContact} alt="LinkedIn" className="w-8 h-8" /></a>
                <a href="https://www.youtube.com/@KalathiyaInfotech"><img src={youtubeContact} alt="YouTube" className="w-8 h-8" /></a>
              </div>
            </div>
            <div className="w-full md:w-1/2 h-full">
              <div className="bg-purple-600 w-full p-4 sm:p-12 md:rounded-r-xl">
                <h2 className="text-white text-xl font-bold mb-6">Contact us</h2>
                <form onSubmit={contactFormik.handleSubmit} className="space-y-4">
                  <div>
                    <input type="text" name='name' value={contactFormik.values.name} onChange={contactFormik.handleChange} onBlur={contactFormik.handleBlur} placeholder="Name" className="w-full px-4 py-2 rounded-full border border-white bg-transparent text-white placeholder-white focus:outline-none" />
                    {contactFormik.touched.name && contactFormik.errors.name && (<div className="text-red-500 text-sm mt-1">{contactFormik.errors.name}</div>)}
                  </div>
                  <div>
                    <input type="email" name='email' value={contactFormik.values.email} onChange={contactFormik.handleChange} onBlur={contactFormik.handleBlur} placeholder="Email" className="w-full px-4 py-2 rounded-full border border-white bg-transparent text-white placeholder-white focus:outline-none" />
                    {contactFormik.touched.email && contactFormik.errors.email && (<div className="text-red-500 text-sm mt-1">{contactFormik.errors.email}</div>)}
                  </div>
                  <div>
                    <input type="text" name='phoneNo' value={contactFormik.values.phoneNo} onChange={contactFormik.handleChange} onBlur={contactFormik.handleBlur} placeholder="Mobile Number" className="w-full px-4 py-2 rounded-full border border-white bg-transparent text-white placeholder-white focus:outline-none" />
                    {contactFormik.touched.phoneNo && contactFormik.errors.phoneNo && (<div className="text-red-500 text-sm mt-1">{contactFormik.errors.phoneNo}</div>)}
                  </div>
                  <div>
                    <input type="text" name='subject' value={contactFormik.values.subject} onChange={contactFormik.handleChange} onBlur={contactFormik.handleBlur} placeholder="Subject" className="w-full px-4 py-2 rounded-full border border-white bg-transparent text-white placeholder-white focus:outline-none" />
                    {contactFormik.touched.subject && contactFormik.errors.subject && (<div className="text-red-500 text-sm mt-1">{contactFormik.errors.subject}</div>)}
                  </div>
                  <div>
                    <textarea name='message' value={contactFormik.values.message} onChange={contactFormik.handleChange} onBlur={contactFormik.handleBlur} placeholder="Message" rows="5" className="w-full px-4 py-2 rounded-2xl border border-white bg-transparent text-white placeholder-white focus:outline-none resize-none"></textarea>
                    {contactFormik.touched.message && contactFormik.errors.message && (<div className="text-red-500 text-sm">{contactFormik.errors.message}</div>)}
                  </div>
                  <div>
                    <div className="bg-white border border-gray-300 rounded shadow-sm px-4 py-2 inline-block w-full max-w-xs">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-3">
                          <input type="checkbox" name='check' checked={contactFormik.values.check} onChange={contactFormik.handleChange} onBlur={contactFormik.handleBlur} className="w-5 h-5 border-2 border-gray-600 rounded focus:ring-0 cursor-pointer" />
                          <label className="text-sm text-black cursor-pointer">I'm not a robot</label>
                        </div>
                        <div className="flex flex-col items-center">
                          <img src="https://www.gstatic.com/recaptcha/api2/logo_48.png" alt="reCAPTCHA" className="h-6" />
                          <p className="text-[10px] text-gray-500 leading-tight text-center mt-1">reCAPTCHA<br /><span className="underline cursor-pointer">Privacy</span> - <span className="underline cursor-pointer">Terms</span></p>
                        </div>
                      </div>
                    </div>
                    {contactFormik.touched.check && contactFormik.errors.check && (<div className="text-red-500 text-sm mt-1">{contactFormik.errors.check}</div>)}
                  </div>
                  <div className="pt-4"><button type="submit" className="bg-white text-purple-600 px-8 py-2 rounded-full font-semibold hover:bg-purple-100 transition">Send</button></div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ContactUs